<app-dialog>
  <app-dialog-title>
    {{ 'HOME.FOODBACKS.CONTACTED.UPDATE_CONTACT_STATUS' | translate }}
  </app-dialog-title>
  <app-dialog-content>
    <form [formGroup]="form">
      <div class="contact-form__fields">
        <app-select
          data-testid="select-contact-status"
          [items]="contactStatuses"
          [label]="'SHARED.SYSTEM.STATUS' | translate"
          [required]="true"
          [isSearchModeEnable]="false"
          formControlName="isContacted" />
        @if (isContacted) {
          <app-select
            data-testid="select-owner"
            [items]="users"
            [label]="'SHARED.SYSTEM.OWNER' | translate"
            [required]="true"
            [isSearchModeEnable]="true"
            formControlName="ownerUuid" />
        }
      </div>
      @if (isContacted) {
        <app-textarea-with-counter
          data-testid="textarea-contact-notes"
          formControlName="note"
          [label]="'HOME.FOODBACKS.CONTACTED.INTERNAL_NOTES' | translate"
          [placeholder]="'HOME.FOODBACKS.CONTACTED.INTERNAL_NOTES' | translate"
          [maxLength]="CONSTANTS.VALIDATION.CONTACT.NOTE_MAX_LENGTH"
          [minHeight]="CONSTANTS.ELEMENTS_HEIGHT.PX_70" />
      }
    </form>
  </app-dialog-content>
  <app-dialog-actions>
    <button
      matButton="outlined"
      type="button"
      class="me-1"
      data-testid="btn-dialog-cancel"
      (click)="hide()">
      {{ 'ACCOUNT.FOLDER.QR_URLS.BUTTONS.CANCEL' | translate }}
    </button>
    <button
      matButton="filled"
      type="button"
      data-dismiss="modal"
      data-testid="btn-dialog-save"
      (click)="save()">
      {{ 'SHARED.SYSTEM.SAVE' | translate }}
    </button>
  </app-dialog-actions>
</app-dialog>
